<template>
  <div>
    <Header>
      入力完了
    </Header>

    <div class="py-4 mx-3">
      <div class="text-center mb-4">
        <p class="text-size-18 title">
          審査を開始しました！
        </p>
        <p class="text-size-14">
          審査完了後、メールアドレスに認証結果を送信します
        </p>
      </div>
      <div class="text-center mascot">
        <img src="@/assets/img/caikuma_02_a.png" />
      </div>
      <div class="text-size-14 text-center information">
        審査は<span class="text-size-18 text-weight-600">1</span
        ><span class="text-weight-600">時間以内</span>で完了します
      </div>
      <p class="mt-3 text-size-12 text-mild">
        認証結果が届かない場合、<RouterLink
          :to="{ name: 'Mypage' }"
          class="text-primary"
          >マイページ</RouterLink
        >からご連絡ください。
      </p>

      <div class="mt-4 promotion">
        <p class="text-size-16 text-weight-500">
          招待コードの登録
        </p>
        <p class="mt-1 text-size-12 text-mild">
          招待コードを登録いただき資格認証完了後30日以内にお仕事をすると、招待した方にポイントが付与されます。
        </p>
        <CustomValidationObserver ref="vObserver" v-slot="{ handleSubmit }">
          <ValidationProvider
            v-slot="validationState"
            name="招待コード"
            :rules="{ required: true, length: 8 }"
            vid="code"
          >
            <TextFieldGroup
              v-model="code"
              label="招待コード"
              placeholder=""
              :validationState="validationState"
              :disabled="isCodeApplied"
              class="mt-2"
            ></TextFieldGroup>
          </ValidationProvider>

          <AppButton
            block
            class="mt-3"
            variant="success"
            :disabled="isCodeApplied"
            @click="handleSubmit(onClickSubmitCode)"
            data-testid="submit-code-button"
          >
            {{ submitCodeButtonLabel }}
          </AppButton>
        </CustomValidationObserver>
      </div>
      <AppButton
        block
        class="mt-4"
        @click="onClickGoToSearch"
        data-testid="to-search-button"
      >
        仕事一覧へ
      </AppButton>
    </div>
    <BlockBack />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import { AbTest3113 } from "@/app/services/AbTestService";
import Header from "@/components/organisms/common/Header.vue";
import { accountService } from "@/app/services/AccountService";
import { ErrorType, showErrorModal } from "@/utils/showErrorModal";
import { authStore } from "@/store/auth";
import BlockBack from "@/components/organisms/common/BlockBack.vue";
import { routerPush } from "@/utils/routerPush";
import TextFieldGroup from "@/components/molecules/form/TextFieldGroup.vue";
import AppButton from "@/components/atoms/button/AppButton.vue";
import { inAppReviewService } from "@/app/services/InAppReviewService";

@Component({
  components: {
    Header,
    BlockBack,
    TextFieldGroup,
    AppButton
  }
})
export default class FinishSignupTemplate extends Vue {
  code: string | null = null;
  isCodeApplied = false;

  get submitCodeButtonLabel() {
    return this.isCodeApplied ? "登録完了" : "招待コードを登録する";
  }

  async created() {
    try {
      this.$loading.show();

      // このコンポーネントは「アカウント登録からのフロー」「マイページからのフロー」で利用されている。
      // アカウント登録からのフローでは既にアカウント認証依頼のリクエストを行っているため、初回認証申請を行っているかをチェックする。
      if (!authStore.hasRegisteredProfile) {
        await accountService.initialProfileRegister();
        const userData = await accountService.fetchUserData();
        authStore.changeUserInfo(userData);
      }
      AbTest3113.registerEvent(
        AbTest3113.eventTypes.completeAccountApplication
      );
    } catch (error) {
      showErrorModal(this, error as ErrorType);
    } finally {
      this.$loading.hide();
    }
  }

  async mounted() {
    await inAppReviewService.launchInAppReview("REQUEST_ACCOUNT");
  }

  async onClickSubmitCode() {
    try {
      this.$loading.show();
      await accountService.applyReferPromotionCode({ code: this.code! });
      this.isCodeApplied = true;
      await this.$bvModal.msgBoxOk("招待コードが登録されました。", {
        centered: true
      });
    } catch (error) {
      await showErrorModal(this, error as ErrorType);
    } finally {
      this.$loading.hide();
    }
  }

  async onClickGoToSearch() {
    await routerPush(this, { name: "Search" });
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: 600;
  line-height: 30.6px;
}

.mascot {
  margin-bottom: 2.5rem;
}

.information {
  padding: 8px;
  line-height: 34.2px;
  background-color: $primary-bg;
  border: 1px solid $primary-yellow;
  border-radius: 4px;
}

.promotion {
  padding: 1rem 1.5rem;
  border: 1px solid #8f8f8f;
  border-radius: 4px;
}
</style>
